/* exported bocAmchart4 */
/* global am4core */

/**
 * Container object for Bank of Canada functions for setting up AmCharts
 */
var bocAmchart4 = {};
am4core.options.autoSetClassName = true;
am4core.options.deferredDelay = 0;
am4core.options.minPolylineStep = 3;
am4core.options.queue = true;


/**
 * Version file, listing the features implemented, latest at the end of the array (under features),
 * make sure to separate the tasks to avoid merge conflicts
 * The entries could be deleted after they are code released on prod (not via uploads)
 * @type {{svn: string, features: string[]}}
 */
bocAmchart4.version = {
    "svn": "$Revision: 34201 $".match(/\$Revision:\s*(\d+)\s*\$/)[1],
    "date": "$Date: 2024-09-06 $".match(/\$Date:\s*(.+)\s*\$/)[1],
    "features": {}
};

bocAmchart4.version.features['DEV-8803-Maps-manual-buckets'] = [
    'Added manual buckets for maps when markerCount is greater than 1',
    'Set up default heat legend when markerCount is equal to 1',
    'Added calculation of min/maxValues for getObservationsByCategory',
    'Added heatmap/map parameters to params.js',
    'Added logarithmic intervals functionality',
    'Updated the decimal points displaying in legend'
];

bocAmchart4.version.features['DEV-8802-Heatmaps-fixes'] = [
    'Added sorting of heatmap categories by series order',
    'Removed hardcoded min grid distance, so that overrides work',
    'Fixed the issue with values arising from adding rounding errors',
    'Removed other instances of hardcoded rounding to .00',
    'Added tooltip formatter param use for maps '
];

bocAmchart4.version.features['DEV-8812'] = [
    'Fixed hashed columns not working on print error',
    'Added a second overlay (striped) to the legend marker',
    'Modified bocSettingsObject to include second overlay intercepting adapter "fill" '
];

bocAmchart4.version.features['DEV-8847-Dark-mode-context-print'] = [
    'Fixed dark mode print error - legend not showing up',
    'invert(color) was causing the text color to blend in with background',
    'Removed inversion of colors in the chart',
    'Charts now retain the dark background on print and labels are visible',
    'Cleaning up the code, removing old changelog'
];
bocAmchart4.version.features['DEV-8909-Amcharts-tests-fix'] = [
    'Fixed the jsErrors not working because of added const'
];

bocAmchart4.version.features['DEV-8729'] = [
    'Fixed label wrapping and tick marks on print for multilevel labels',
    'Added label wrapping to sizechanged and validated events',
    'Created new function for label wrapping'
];

bocAmchart4.version.features['DEV-8956-Interactive fixes'] = [
    "DMPR Fixes",
    "Better fix for notes autohide",
    "Changing the classes to be from 1 to 4 and allow manual override in interactive parameters"
];

bocAmchart4.version.features['DEV-8834-x-Axis titles off centered on print'] = [
    'Deep invalidate x-axis of charts with horizontal text labels in the y-axis and an x-axis title',
    'Above step is performed during print copy generation',
    'Refactor safe access to chart axes and properties for broader browser compatibility'
];

bocAmchart4.version.features['DEV-8965-Heatmaps-decimal-point-translation'] = [
    'Added decimalCount as a parameter to toLocaleString()',
    'Added minValue/maxValue calculations to getObservationsinTwoDimensions()',
    'Created a separate function for locale and decimalCount'
];

bocAmchart4.version.features['DEV-7667-Add-analytics-events-for-interactive-charts-selects'] = [
    'Added new analytics.js file to handle analytics events',
    'Created analytics event triggers for when interactive selects options are chosen',
    'Fixed analytics on export, chart titles are now grabbed properly',
    'Added analytics to interactive charts dropdown ',
    'Added analytics on chart annotations activation',
    'Added analytics to amcharts4 legends and selectable charts legends',
    'Improved getChartTitle() helper function'
];

bocAmchart4.version.features['DEV-8960-Add amcharts4 helper functions to parameters documentation.'] = [
    'Added documentation for callback functions',
    'Added context info (data or regular callback)'
];


bocAmchart4.version.features['DEV-8805-Change-color-and-shape-of-specific-data-points-in-scatter-plots'] = [
    'Added customizeBullets.js to hold logic for modifying chart data-points',
    'Implemented helper functions for creating the svg, and setting visibility events'
];

bocAmchart4.version.features['DEV-8804-Add-the-ability-to-add-arrow-heads-to-lines-in-our-charts'] = [
    'Added annotations.js for arrows and labels feature',
    'Added behat tests amcharts4_annotations.feature',
    'Fixed modified-bullets for \'scatter\' and \'marker\' datatype',
    'Added functionality to specify arrow color with color index',
    'Adding zIndex to arrows properly',
    'Fixed positioning of all labels',
    'Adjusted arrow head rotation functionality'
];

bocAmchart4.version.features['DEV-8960-CAdd amcharts4 helper functions to parameters documentation.'] = [
    'Added documentation for callback functions'
];

bocAmchart4.version.features['DEV-9004-Add-midcolor-labels-for-heatmap-legend'] = [
    'Fixed positioning of all labels'
];
